import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DeleteIcon from '../../v2/icons/DeleteIcon';
import { getClassName } from '../../../utils/ui/classes';
const AccessorialCard = ({ selected, canSelect, canDelete, iconSlug, name, className, onSelect, onDelete, size, }) => {
    function handleSelect(e) {
        if (!canSelect) {
            return;
        }
        e.preventDefault();
        onSelect();
    }
    function handleDelete(e) {
        e.stopPropagation();
        e.preventDefault();
        onDelete();
    }
    return (React.createElement("div", { className: getClassName(className) },
        React.createElement("div", { className: getAccessorialClass({ selected, canSelect, size }), onClick: canSelect && handleSelect },
            React.createElement("div", { className: "flex flex-col items-center justify-center" },
                React.createElement("i", { className: getIconClass(iconSlug) }),
                React.createElement("span", { className: "mt-1 text-center" }, name)),
            canDelete && (React.createElement("button", { className: "absolute top-0 right-0 flex items-center justify-center w-10 h-10 text-grey hover:text-grey-darker", onClick: handleDelete },
                React.createElement(DeleteIcon, null))))));
};
AccessorialCard.propTypes = {
    selected: PropTypes.bool,
    canSelect: PropTypes.bool,
    canDelete: PropTypes.bool,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    iconSlug: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    size: PropTypes.string,
};
AccessorialCard.defaultProps = {
    selected: false,
    canSelect: false,
    canDelete: false,
    size: 'normal',
};
export default AccessorialCard;
const baseClasses = [
    'relative',
    'flex',
    'items-center',
    'justify-center',
    'bg-white',
    'shadow',
    'rounded',
    'border-2',
];
function getAccessorialClass({ selected = false, canSelect = false, size = 'normal', }) {
    return getClassName(baseClasses, {
        'border-transparent': !selected,
        'border-green': selected,
        'border-solid': selected,
        'cursor-pointer': canSelect,
        'w-40': size === 'normal',
        'h-40': size === 'normal',
        'w-32': size === 'small',
        'h-32': size === 'small',
    });
}
function getIconClass(iconSlug) {
    const className = {
        'mx-0': true,
    };
    if (iconSlug) {
        className['icon-normal'] = true;
        className[iconSlug] = true;
    }
    return classnames(className);
}
